import { render, staticRenderFns } from "./website.vue?vue&type=template&id=6f1c77e6&scoped=true"
import script from "./website.vue?vue&type=script&lang=js"
export * from "./website.vue?vue&type=script&lang=js"
import style0 from "./website.vue?vue&type=style&index=0&id=6f1c77e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c77e6",
  null
  
)

export default component.exports